
import { defineComponent, ref } from 'vue'

const TABS = [
    { id: 'campaigns', label: 'Аудиорассылки' },
    { id: 'flow', label: 'Настройка запуска' },
    { id: 'analytics', label: 'Аналитика' },
] as const

const CAMPAIGNS = [
    {
        title: 'Потерянные клиенты · Сентябрь',
        meta: '3 124 клиента · запущено сегодня',
        status: 'active',
        statusLabel: 'Запущена',
        metric: '32 лида',
        action: 'Подробно',
        primary: true,
    },
    {
        title: 'Горячие клиенты · Август',
        meta: '1 840 клиентов · завершено',
        status: 'done',
        statusLabel: 'Завершена',
        metric: '18 лидов',
        action: 'Подробно',
        primary: false,
    },
    {
        title: 'Недозвон · повторная попытка',
        meta: '682 клиента · черновик',
        status: '',
        statusLabel: 'Черновик',
        metric: '—',
        action: 'Редактировать',
        primary: false,
    },
] as const

const STEPS = [
    {
        num: '1',
        title: 'Сегмент',
        text: 'Выберите сегмент и исключите клиентов с будущей записью.',
        audio: false,
    },
    {
        num: '2',
        title: 'Аудио',
        text: 'Выберите одобренную запись из вкладки «Аудио».',
        audio: true,
    },
    {
        num: '3',
        title: 'Расписание',
        text: 'Утро, день, вечер или своё время звонков.',
        audio: false,
    },
    {
        num: '4',
        title: 'Запуск',
        text: 'Проверьте настройки и баланс телефонии перед запуском.',
        audio: false,
    },
] as const

const KPIS = [
    { label: 'Всего звонков', value: '18 642' },
    { label: 'Дозвонились', value: '7 432' },
    { label: 'Тёплые лиды', value: '512' },
    { label: 'Записаны', value: '178' },
] as const

const FUNNEL = [
    { label: 'Все звонки', value: '18 642', width: '100%', tone: '' },
    { label: 'Дозвон', value: '7 432', width: '39.9%', tone: '' },
    { label: 'Нажали 5', value: '1 284', width: '6.9%', tone: 'is-teal' },
    { label: 'Записаны', value: '178', width: '0.95%', tone: 'is-accent' },
] as const

export default defineComponent({
    name: 'ZvonoBotPreview',
    setup() {
        const activeTab = ref<(typeof TABS)[number]['id']>('campaigns')

        const openCampaign = (action: string) => {
            activeTab.value = action === 'Редактировать' ? 'flow' : 'analytics'
        }

        return {
            tabs: TABS,
            campaigns: CAMPAIGNS,
            steps: STEPS,
            kpis: KPIS,
            funnel: FUNNEL,
            activeTab,
            openCampaign,
        }
    },
})
